module.exports = __webpack_public_path__ + "static/media/1 como vender-min.85b8ba06.jpg";